import type { Options } from 'highcharts';
import {
  MetricsEnum,
  MediumEnum,
  DatasetWithMediums,
  MediumMetric,
  Mediums,
} from 'modules/iterableGoals/types';
import { mediumColors } from '../constants/goalContributionsByMedium';

export const calculateMediumValuesTotal = (data: Record<MediumEnum, MediumMetric>) =>
  Object.values(data).reduce((total, { value }) => total + value, 0);

export const getChannelData = (data: DatasetWithMediums, medium: MediumEnum) => {
  const { value: contributions } =
    data.overallMetrics[MetricsEnum.TOTAL_CONVERSIONS].mediums[medium];
  const { value: sends } = data.overallMetrics[MetricsEnum.TOTAL_SENT].mediums[medium];

  return {
    sends,
    contributions,
  };
};

export const getChartOptions = (
  contributionsData: [MediumEnum, MediumMetric, string][],
): Options => ({
  chart: {
    type: 'bar',
    height: 24,
    marginTop: 0,
    spacingTop: 0,
    spacingBottom: 0,
    marginBottom: 0,
    spacingLeft: 0,
    spacingRight: 0,
    marginLeft: 0,
    marginRight: 0,
  },
  title: {
    text: undefined,
  },
  credits: {
    enabled: false,
  },
  legend: {
    enabled: false,
  },
  tooltip: {
    enabled: false,
  },
  navigation: {
    buttonOptions: {
      enabled: false,
    },
  },
  plotOptions: {
    series: {
      stacking: 'percent',
    },
  },
  xAxis: {
    visible: false,
  },
  yAxis: {
    visible: false,
    min: 0,
    max: 100,
  },
  series: contributionsData.map(([, data, color]) => ({
    type: 'bar',
    color,
    data: [data.value],
    pointWidth: 24,
  })),
});

export const sortMediumData = (mediumData: Mediums) =>
  (Object.entries(mediumData) as [MediumEnum, MediumMetric][])
    .sort((a, b) => b[1]?.value - a[1]?.value)
    .map<[MediumEnum, MediumMetric, string]>((data, i) => {
      return [...data, mediumColors[i]];
    });
